import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
    signedIn: boolean;
    token: string | null;
    idToken: string | null;
    isVerified: boolean;
    isLoading: boolean;
    sessionExpiry?: number | null;
}

const initialState: AuthState = {
    signedIn: false,
    token: null,
    idToken: null,
    isVerified: false,
    isLoading: false,
    sessionExpiry: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        signInSuccess: (state, action: PayloadAction<{
            token: string;
            idToken?: string | null;
        }>) => {
            state.signedIn = true;
            state.token = action.payload.token;
            state.idToken = action.payload.idToken !== undefined ? action.payload.idToken : null;
        },
        signOutSuccess: (state) => {
            state.signedIn = false;
            state.token = null;
            state.idToken = null;
            state.isVerified = false;
        },
        setVerificationStatus: (state, action: PayloadAction<boolean>) => {
            state.isVerified = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        refreshSession: (state, action: PayloadAction<{ token: string; idToken?: string }>) => {
            state.token = action.payload.token;
            state.idToken = action.payload.idToken || state.idToken;
        },
    },
});

export const {
    signInSuccess,
    signOutSuccess,
    setVerificationStatus,
    setLoading,
    refreshSession,
} = authSlice.actions;

export default authSlice.reducer;
